import axios from "axios";
import { apiUrl, PORT } from "../../environment";
// import { getInfo } from "./Auth.header";
import queryString from "query-string";
import { toast } from "react-toastify";
import axiosClient from "./axiosClient";

/**
 * @description registration in db.
 * @param {*} data
 * @param {*} callback
 */

// Get total patient count
export const getTotalPatientCount = async () => {
  try {
    const response = await axiosClient.get(`/patient-service/analytics/get-patients-count`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching total patient count:", err);
    toast.error("An error occurred while fetching total patient count.");
  }
};

// Get total doctor count
export const getTotalDoctorCount = async () => {
  try {
    const response = await axiosClient.get(`/user-service/analytics/get-provider-count`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching total doctor count:", err);
    toast.error("An error occurred while fetching total doctor count.");
  }
};

// Get total doctor count
export const getTotalForumCount = async () => {
  try {
    const response = await axiosClient.get(`/user-service/analytics/get-forum-count`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching total doctor count:", err);
    toast.error("An error occurred while fetching total doctor count.");
  }
};


// Get total doctor count
export const getAverageRating = async () => {
  try {
    const response = await axiosClient.get(`/user-service/analytics/platform-rating`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching total doctor count:", err);
    toast.error("An error occurred while fetching total doctor count.");
  }
};
// Get survey statistics
export const getSurveyStatistic = async () => {
  try {
    const response = await axiosClient.get(`/user-service/analytics/get-survey-statistic`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching survey statistics:", err);
    toast.error("An error occurred while fetching survey statistics.");
  }
};

// Get registered doctors in last month
export const getRegisterDoctorInLastMonth = async () => {
  try {
    const response = await axiosClient.get(`/user-service/analytics/get-register-provider-in-sixmonth`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching registered doctors in last month:", err);
    toast.error("An error occurred while fetching registered doctors in last month.");
  }
};

// Get adherence statistics
export const getAdheranceStatistic = async () => {
  try {
    const response = await axiosClient.get(`/medication-service/analytics/get-adherance-statistics`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching adherence statistics:", err);
    toast.error("An error occurred while fetching adherence statistics.");
  }
};

export const getPatientEngagementBySymtoms = async () => {
  try {
    const response = await axiosClient.get(`/patient-service/analytics/patients-engagement`);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    console.error("Error fetching adherence statistics:", err);
    toast.error("An error occurred while fetching adherence statistics.");
  }
};

// download responses pdf of patient 

export const downloadResponsePDF = async (params) => {
  try {
    const response = await axiosClient.get(`/patient-service/report-generate-response`,
      {
        responseType: "blob",
        params,
        headers: {
          'Accept': 'application/pdf',
          'Content-Type': 'application/pdf',
        }
      }
    );

    toast.success("PDF exported successfully");

    return response;


  } catch (err) {
    toast.error("An error occurred while fetching adherence statistics.");
    return null;
  }
};



// Get SYMPTOMS TREND 
export const getFetchSymtoms = async (params) => {

  try {
    const response = await axiosClient.get(`patient-service/get-symptom-trend`, { params });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching adherence statistics.");
  }
};
